import {useState, useEffect} from 'react'
import {UserModel, AuthModel} from '../../../modules/auth'
import {useAuth} from '../../../modules/auth/core/Auth'
import {login, getUserByToken} from '../../../modules/auth/core/_requests'
import {ConnectAndHealLinkWidget} from '../../../modules/futurisk/ConnectAndHealLinkWidget'
import {DashboardLinkWidget} from '../../../modules/futurisk/DashboardLinkWidget'
import {WebViewLinkWidget} from '../../../modules/futurisk/WebView/WebViewLinkWidget'
import {toAbsoluteUrl} from '../../../../_metronic/helpers/AssetHelpers'
import {NomineeWidget} from '../../../modules/futurisk/Nominee/NomineeWidget'
import {PristynCareAdd} from '../../../modules/futurisk/pristyncare/PristynCareAdd'
import {LivLongWidget} from '../../../modules/futurisk/LivLong/LivLongWidget'
import {RetailWidget} from '../../../modules/futurisk/Retail/RetailWidget'
import {RetailHealthWidget} from '../../../modules/futurisk/Retail Health/RetailHealthWidget'
import {ApolloWidget} from '../../../modules/futurisk/apollo/ApolloWidget'
import {AmuraWidget} from '../../../modules/futurisk/Amura/AmuraWidget'
import { PostureScanWidget } from '../../../modules/futurisk/PostureScan'
import { FaceScanWidget } from '../../../modules/futurisk/FaceScan'
import { SevaWidget } from '../../../modules/futurisk/Seva/SevaWidget'

export function ValueAdds() {
  const [error] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [valueAddsData, setValueAddsData] = useState<UserModel | null>(null)
  const authContext = useAuth()
  const a: AuthModel | undefined = authContext.auth
  const auth: AuthModel = login(a?.username!, a?.password!, 'valueadds')

  useEffect(() => {
    ;(async () => {
      var data = await getUserByToken(auth)
      if (data.data.Status === 'Success') {
        setValueAddsData(data.data)
        setIsLoaded(true)
      }
    })()
  }, [])

  const currentUser = valueAddsData

  if (error) {
    return <></>
  } else if (!isLoaded) {
    return (
      <div className='row g-5 g-xl-8 my-5'>
        <div
          className='card shadow mb-5 mb-xl-5 bgi-no-repeat'
          style={{
            backgroundPosition: 'right top',
            backgroundSize: '30% auto',
            backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
          }}
        >
          <div className='card-body pt-9 pb-9'>
            <span>Customizing Your Welnesss Services...</span>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <>
        <div className='row g-5 g-xl-8 col-xl-6'></div>
        {/* begin::Row */}
        <div className='row g-5 g-xl-8 my-5'>
            {currentUser?.CRMClientId === 910 && (
              <NomineeWidget
                className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
                title={'Nominee Declaration GPA/GTL'}
                description={'Nominee Declaration GPA/GTL'}
                avatar={''}
                link={undefined}
              />
            )}

          

          {currentUser?.CRMClientId === 1133 && (
            <NomineeWidget
              className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
              title={'Nominee Declaration GPA/GTL'}
              description={'Nominee Declaration GPA/GTL'}
              avatar={''}
              link={undefined}
            />
          )}

          {currentUser?.CRMClientId === 964 && (
            <NomineeWidget
              className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
              title={'Nominee Declaration GPA/GTL'}
              description={'Nominee Declaration GPA/GTL'}
              avatar={''}
              link={undefined}
            />
          )}

          {
            currentUser?.CRMClientId === 978 && <AmuraWidget
              className='card-xl-stretch bg-light-primary border-secondary border-hover-primary border'
              title='Amura Health'
              description='Weight Loss Program'
              avatar=''
              link={undefined}
            />
          }

          {currentUser?.Tabs.map((tab, index) => {
            if (tab.Identifier === 'sevaathome' && tab.Action === 'signup') {
              return (
                <ConnectAndHealLinkWidget
                  key={`${index}`}
                  className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
                  avatar={tab.Icon}
                  title={tab.Name}
                  description={tab.Description}
                  link={tab.Url}
                />
              )
            } else if (tab.Identifier === 'sevaathomelink' && tab.Action === 'download') {
              return (
                <SevaWidget
                  key={`${index}`}
                  className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
                  avatar={tab.Icon}
                  title={tab.Name}
                  description={tab.Description}
                  link={tab.Url}
                />
              )
            }

            if (tab.Identifier === 'pristyncare') {
              return (
                <PristynCareAdd
                  className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
                  avatar={tab.Icon}
                  title={tab.Name}
                  description={tab.Description}
                  link={tab.Url}
                />
              )
            }

            if (tab.Identifier === 'apollo247') {
              return (
                <ApolloWidget
                  className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
                  title={'Apollo Health Checkup'}
                  description={'Book your health checkup appointment with Apollo'}
                  avatar={'apollo.png'}
                  link={undefined}
                  currentUser={currentUser}
                />
              )
            }

            if (tab.Action === 'view') {
              return (
                <div key={`${index}`} className='col-xl-12'>
                  <WebViewLinkWidget
                    className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
                    avatar={tab.Icon}
                    title={tab.Name}
                    description={tab.Description}
                    link={tab.Url}
                  />
                </div>
              )
            } else {
              return (
                <div key={`${index}`} className='col-xl-12' style={{padding: 0}}>
                  <DashboardLinkWidget
                    className='card-xl-stretch shadow bg-light-primary border-secondary border-hover-primary border'
                    avatar={tab.Icon}
                    title={tab.Name}
                    description={tab.Description}
                    link={tab.Url}
                  />
                </div>
              )
            }
          })}

          {
            <RetailWidget
              className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
              title={'Retail Offers'}
              description={'Exclusive Retail Offers'}
              avatar={''}
              link={undefined}
            />
          }

          {
            <RetailHealthWidget
              className='card-xl-stretch mb-xl-8 bg-light-primary border-secondary border-hover-primary border'
              title={'Retail Offers'}
              description={'Exclusive Retail Offers'}
              avatar={''}
              link={undefined}
            />
          }

          {
            <FaceScanWidget className="optional-class" />

          }
          {
            <PostureScanWidget className="optional-class" />
          }

          {
            currentUser?.CRMClientId !== 978 && <AmuraWidget
              className='card-xl-stretch bg-light-primary border-secondary border-hover-primary border'
              title='Amura Health'
              description='Weight Loss Program'
              avatar=''
              link={undefined}
            />
          }

          {/* {currentUser?.CRMClientId !== 369 && (
            <LivLongWidget
              className='card-xl-stretch bg-light-primary border-secondary border-hover-primary border'
              title='LivLong'
              description='Wellness Partner'
              avatar=''
              link='#'
            ></LivLongWidget>
          )} */}
        </div>
        {/* end::Row */}
      </>
    )
  }
}
